import React from 'react';
import PropTypes from 'prop-types';
import PlayStatus from './utils/PlayStatus';
import PlayAction from './playEvents/PlayAction';
import { PlayDot, PlayEventsWrapper } from './PlayEvents.style';

export const PlayEventTypes = {
    ACTION: 'action',
    PICKOFF: 'pickoff',
    PITCH: 'pitch',
    NO_PITCH: 'no_pitch',
    STEPOFF: 'stepoff',
    BATTER_TIMEOUT: 'batter_timeout',
    MOUND_VISIT: 'mound_visit'
};

const PlayEvents = ({
    data,
    playEventType,
    offset = false,
    outCount,
    count
}) => {
    const {
        ACTION,
        PICKOFF
    } = PlayEventTypes;

    const {
        details = {},
        isBaseRunningPlay = false
    } = data;

    const {
        event,
        description
    } = details;

    const isAction = playEventType === ACTION;

    let datafield;
    const successfulPickoff = playEventType === PICKOFF && isBaseRunningPlay;
    if (isAction || playEventType === PICKOFF) {
        if (event || description) {
            datafield = (
                <PlayAction event={ (isAction || successfulPickoff) ? event : undefined } description={ description } />
            );
        }
    }

    // Can modify this later once we have other criteria for showing status
    const showPlayStatus = successfulPickoff;

    // For the future if we include pitch events
    // else if (playEventType === PITCH) {

    // }
    return (
        <PlayEventsWrapper
            $offset={ offset }
            showPlayStatus={ showPlayStatus }
        >
            <PlayDot
                $offset={ offset }
            />

            { datafield }

            { showPlayStatus ? <PlayStatus
                isPlayEvent
                hideCount
                outCount={ outCount }
                count={ count }
            /> : null }
        </PlayEventsWrapper>
    );
};

PlayEvents.propTypes = {
    playEventType: PropTypes.oneOf(Object.values(PlayEventTypes)),
    data: PropTypes.object,
    offset: PropTypes.bool,
    outCount: PropTypes.number,
    count: PropTypes.object,
    isBaseRunningPlay: PropTypes.bool
};

export default PlayEvents;
